module.exports = {
      id: "envelope-usage",
      viewBox: "0 0 160 120",
      url: __webpack_public_path__ + "svg-sprite-c71831da97eff2ec188167649c252867.svg#envelope",
      toString: function () {
        return this.url;
      }
    }